import * as React from "react";
import { styled } from "@mui/material";
import emptyPlaceholder from "../assets/emptystate-articles.png";
//region [[ Styles ]]

const EmptyPlaceholder = styled("img")({
  maxWidth: "100%",
});

const CoronaEmptyGraphContainerView = styled("div")(({ theme }) => ({
  display: "flex",
  flexFlow: "column",
  alignItems: "center",
  justifyContent: "center",
  margin: theme.spacing(2),
  minWidth: "520px",
  [theme.breakpoints.down("sm")]: {
    minWidth: "480px",
  },
  [theme.breakpoints.down("xs")]: {
    minWidth: "300px",
  },
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface CoronaEmptyGraphContainerProps {
  children?: React.ReactNode;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const CoronaEmptyGraphContainer = ({
  ...props
}: CoronaEmptyGraphContainerProps) => (
  <CoronaEmptyGraphContainerView>
    <EmptyPlaceholder
      src={emptyPlaceholder}
      alt={"Select axis to view articles. Select keyword to view connections"}
    />
    {props.children}
  </CoronaEmptyGraphContainerView>
);
